import React from 'react';
import { Timer, Plus } from 'lucide-react';

interface TokenBalanceProps {
  minutes: number;
  onPurchase: () => void;
}

export function TokenBalance({ minutes, onPurchase }: TokenBalanceProps) {
  const formatTime = (mins: number) => {
    const wholeMinutes = Math.floor(mins);
    const seconds = Math.round((mins - wholeMinutes) * 60);
    return `${wholeMinutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <button
      onClick={onPurchase}
      className="relative group"
    >
      {/* Animated Border */}
      <div className="absolute -inset-[0.5px] bg-gradient-to-r from-primary/50 via-purple-500/50 to-primary/50 rounded-lg opacity-75 group-hover:opacity-100 animate-border-flow" />
      
      {/* Content */}
      <div className={`relative flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background ${
        minutes < 1 
          ? 'text-warning' 
          : 'text-primary'
      } transition-colors`}>
        <Timer className="w-3.5 h-3.5" />
        <span className="font-medium text-sm">{formatTime(minutes)}</span>
        <Plus className="w-3.5 h-3.5" />
      </div>

      {/* Hover Glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-purple-500/20 to-primary/20 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity" />
    </button>
  );
}